<template>
  <div class="container">
    <div class="formulario">
      <div class="titulo"><h2>{{ titulo }}</h2></div>
      <div class="dadosHistorico" >
        <b-alert class="negrito" show>{{ mensagemServidor}}</b-alert>  
        
      </div>
    </div>
  </div>
</template>

<script>

import api from '../api'

export default {

  data () {
    return {
      titulo: 'Requerimento LGPD',
      mensagemServidor: ''
    }
  },

  created() {
    this.confirmaRequerimento(this.$route.query.numero)
  },

  methods: {

    confirmaRequerimento(numeroRequerimento) {
      api.patch('/solicitacoes/' + numeroRequerimento, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },})
      .then(res => {    
        
        if (res.status === 200) {
          this.mensagemServidor = res.data.MESSAGE          
        } else { 
          if (res.data.MESSAGE ) {
            this.mensagemServidor = res.data.MESSAGE; 
          } else {
            this.mensagemServidor = 'Um erro aconteceu em nossos servidores. Tente executar essa ação mais tarde.'  
          }
          
        }})
      .catch(error => {
        console.log(error);
        this.mensagemServidor = error.response.data.MESSAGE || 'Um erro aconteceu em nossos servidores. Tente executar essa ação mais tarde.' ;
        
      })
    },
  }
}
</script>

<style scoped>
.label {
  font-weight: bold;
}
.mt-20 {
  margin-top: 20px;
}
.container {
  background-color: #f8f9fa!important;
}
.negrito {
  font-weight: bold;
}

.formulario {
  width: 80%;
  margin: auto;
  background-color: #f8f9fa !important;
  min-height: 100vh;
}

.titulo {
  margin-top: 20px;
  margin-bottom: 6em;

}

label.d-block {
  font-weight: bold;
}

.container {
  margin: 0px;
  background-color: #f8f9fa !important;
}

.negrito {
  font-weight: bold;
}


.alert-info {
  background-color: transparent;
  border-color: transparent;
}

.alert {
  padding: 0px;
}

.dadosHistorico {
  background-color: white;
  padding-top: 2em;
  padding-left: 2em;
  padding-right: 2em;
}

@media (max-width: 678px) {
  .titulo {
    margin-bottom: 0px;
  }

  .titulo h2{
    font-size: 1.5rem;
  }
}

.modal-body {
  white-space:break-spaces;
}


.modal-content {
  width: fit-content!important;
}

</style>



// WEBPACK FOOTER //
// src/views/ConfirmaRequerimento.vue